<template>
  <vx-card
    class="editor-mid-card"
    :class="{
      'bg-dark-custom': !isAboutTabComplete && aboutDataCalculationFinished,
    }"
    style="position: relative"
  >
    <div v-if="userData && aboutDataCalculationFinished">
      <div v-if="isAboutTabComplete && organizationSlug === 'gala'">
        <personality-gala :personalityData="personalityData" />
      </div>
      <div v-else-if="isAboutTabComplete && organizationSlug === 'dpd-belux'">
        <personality-dpd-belux :personalityData="personalityData" />
      </div>
      <div v-else-if="isAboutTabComplete">
        <personality-default :personalityData="personalityData" />
      </div>
      <div
        v-else-if="userData.email || !isUserLoggedIn"
        class="vertical-center"
      >
        <vx-card>
          <h5 class="mb-base">
            You need to completely fill the
            <router-link
              v-if="$route.name.includes('-custom')"
              :to="{ name: 'editor-about-custom' }"
              >About</router-link
            >
            <router-link v-else :to="{ name: 'editor-about' }"
              >About</router-link
            >
            tab, to unlock Personality tab
          </h5>
          <div class="items-left mb-base">
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isEmailFilled,
                  'text-danger': !isEmailFilled,
                }"
              /><span class="ml-2" style="font-size: 16px">Email</span>
            </div>
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isFirstNameFilled,
                  'text-danger': !isFirstNameFilled,
                }"
              /><span class="ml-2" style="font-size: 15px">First Name</span>
            </div>
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isProfilePictureFilled,
                  'text-danger': !isProfilePictureFilled,
                }"
              /><span class="ml-2" style="font-size: 15px"
                >Profile Picture</span
              >
            </div>
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isDOBFilled,
                  'text-danger': !isDOBFilled,
                }"
              /><span class="ml-2" style="font-size: 15px">Date of Birth</span>
            </div>
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isCareerObjectiveFilled,
                  'text-danger': !isCareerObjectiveFilled,
                }"
              /><span class="ml-2" style="font-size: 15px"
                >Career Objective</span
              >
            </div>
            <div class="flex items-center mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isProfessionFilled,
                  'text-danger': !isProfessionFilled,
                }"
              /><span class="ml-2" style="font-size: 15px">Profession</span>
            </div>
            <div class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                class="w-5 h-5"
                :svgClasses="{
                  'text-success': isAboutFilled,
                  'text-danger': !isAboutFilled,
                }"
              /><span class="ml-2" style="font-size: 15px">About</span>
            </div>
          </div>
          <div class="items-center">
            <vs-button
              v-if="$route.name.includes('-custom')"
              :to="{ name: 'editor-about-custom' }"
              class="w-full"
              style="border-radius: 6px"
              >About Tab</vs-button
            >
            <vs-button
              v-else
              :to="{ name: 'editor-about' }"
              class="w-full"
              style="border-radius: 6px"
              >About Tab</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>
  </vx-card>
</template>

<script>
import PersonalityDefault from "./PersonalityDefault.vue";
import PersonalityDpdBelux from "./PersonalityDpdBelux.vue";
import PersonalityGala from "./PersonalityGala.vue";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  data() {
    return {
      organizationConfig,
      isEmailFilled: false,
      isProfilePictureFilled: false,
      isDOBFilled: false,
      isFirstNameFilled: false,
      isCareerObjectiveFilled: false,
      isProfessionFilled: false,
      isAboutFilled: false,
      aboutDataCalculationFinished: false,
    };
  },
  components: {
    PersonalityDefault,
    PersonalityDpdBelux,
    PersonalityGala,
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      return this.organizationConfig[this.organizationSlug].personalityTraits[
        this.locale
      ]
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
    },
    boardUser() {
      return this.$store.state.boards.userBoardData;
    },
    isAboutTabComplete() {
      if (
        this.isEmailFilled &&
        this.isProfilePictureFilled &&
        this.isDOBFilled &&
        this.isFirstNameFilled &&
        this.isCareerObjectiveFilled &&
        this.isProfessionFilled &&
        this.isAboutFilled
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    userData(newVal) {
      this.verifyAboutTab();
    },
  },
  methods: {
    verifyAboutTab() {
      this.aboutDataCalculationFinished = false;
      if (this.userData) {
        if (this.userData.email) this.isEmailFilled = true;
        if (this.userData.profilePictureUrl) this.isProfilePictureFilled = true;
        if (this.userData.dob) this.isDOBFilled = true;
        if (this.userData.firstName) this.isFirstNameFilled = true;
        if (this.userData.careerObjective) this.isCareerObjectiveFilled = true;
        if (this.userData.profession) this.isProfessionFilled = true;
        if (this.userData.about) this.isAboutFilled = true;

        this.aboutDataCalculationFinished = true;
      }
    },
  },
  mounted() {
    // verify about tab completion
    this.verifyAboutTab();
  },
};
</script>

<style scoped>
.vertical-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bg-dark-custom {
  background-color: lightgray !important;
  transition: none;
}
</style>
